import React from 'react'
import '../scss/GeneroSelector.css'

const GeneroSelector = (props) => {
  // console.info(props)

  return <div>
    <div className={'genero-selector'}>
      <button
        className={'genero-selector__item ' + (props.selectedIndex === 1 ? 'genero-selector__item--active' : '')}
        onClick={props.toggleSexoTodos} >
        Tod@s
      </button>
      <button
        className={'genero-selector__item ' + (props.selectedIndex === 3 ? 'genero-selector__item--active' : '')}
        onClick={props.toogleSexoFemenino} >
        Mujeres
      </button>
      <button
        className={'genero-selector__item ' + (props.selectedIndex === 2 ? 'genero-selector__item--active' : '')}
        onClick={props.toogleSexoMasculino}>
        Hombres
      </button>
    </div>
  </div>
}

export default GeneroSelector



// WEBPACK FOOTER //
// ./src/components/GeneroSelector.js